/**
 * 请求成功状态码
 */
export const SUCCESS_CODE = 0

/**
 * 请求contentType
 */
export const CONTENT_TYPE: AxiosContentType = 'application/json'

/**
 * 请求超时时间（毫秒）：5 分钟。
 * 单接口可在调用时传 timeout 覆盖此全局值。
 */
export const REQUEST_TIMEOUT = 300000

/**
 * 不重定向白名单
 */
export const NO_REDIRECT_WHITE_LIST = ['/login']

/**
 * 不重置路由白名单
 */
export const NO_RESET_WHITE_LIST = [
  'Redirect',
  'RedirectWrap',
  'Login',
  'NoFind',
  'NotFoundFallback',
  'Root',
  'PlatformRoot',
  'PlatformGame',
  'OperationRoot',
  'OperationGameRecord',
  'OperationRewardConfig',
  'OperationCarnivalConfig'
]

/**
 * 表格默认过滤列设置字段
 */
export const DEFAULT_FILTER_COLUMN = ['expand', 'selection']

/**
 * 是否根据headers->content-type自动转换数据格式
 */
export const TRANSFORM_REQUEST_DATA = true

/**
 * 全局图标前缀
 */
export const ICON_PREFIX = 'vi-'
